import { startTransition, useEffect, useRef } from 'react';
export const useMounted = (cb) => {
    const mountedRef = useRef(false);
    // eslint-disable-next-line @qcx/no-invalid-use-effect
    useEffect(() => {
        if (mountedRef.current) {
            return;
        }
        let destroyCb;
        startTransition(() => {
            mountedRef.current = true;
            destroyCb = cb.call(null);
        });
        return () => {
            if (typeof destroyCb === 'function') {
                destroyCb();
            }
            mountedRef.current = false;
        };
    }, []);
};
export const useUnmounted = (cb) => {
    // eslint-disable-next-line @qcx/no-invalid-use-effect
    useEffect(() => () => {
        cb.call(null);
    }, []);
};
